import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { BenefitsSection } from './components/BenefitsSection';
import { FeatureSection } from './components/FeatureSection';
import { TestimonialSection } from './components/TestimonialSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white font-['Manrope']" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <BenefitsSection data-id="element-4" />
        <FeatureSection data-id="element-5" />
        <TestimonialSection data-id="element-6" />
        <CTASection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}